import moment from 'moment-timezone';
import 'moment/locale/fr.js';
import 'moment/locale/fr-ca.js';

export default moment;
